import { render, staticRenderFns } from "./login.vue?vue&type=template&id=19587c8f&"
import script from "./login.vue?vue&type=script&lang=ts&"
export * from "./login.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19587c8f')) {
      api.createRecord('19587c8f', component.options)
    } else {
      api.reload('19587c8f', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=19587c8f&", function () {
      api.rerender('19587c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/login/login.vue"
export default component.exports